if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        if (!opener || !this.querySelector('[data-media-id]')) return;
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const items = Array.from(this.querySelectorAll('[data-media-id]'));
        const requestedId = this.openedBy?.getAttribute('data-media-id');
        const activeMedia = items.find((item) => item.dataset.mediaId === requestedId) || items[0];
        if (!activeMedia) return;
        items.forEach((item) => item.classList.toggle('active', item === activeMedia));
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          const width = activeMedia.getBoundingClientRect().width || activeMedia.width || 0;
          container.scrollLeft = Math.max(0, (width - container.clientWidth) / 2);
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
